import { apiClient } from './client';
import { LoginRequest, LoginResponse, User } from '../../types';

export const authApi = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    return apiClient.post<LoginResponse>('/api/v1/admin/login', credentials);
  },

  logout: async (): Promise<void> => {
    // No specific logout endpoint in backend, just clear local storage
    return Promise.resolve();
  },

  getProfile: async (): Promise<User> => {
    // Backend doesn't have profile endpoint, return user from token
    throw new Error('Profile endpoint not implemented');
  },

  refreshToken: async (): Promise<LoginResponse> => {
    // Backend doesn't have refresh endpoint
    throw new Error('Refresh token endpoint not implemented');
  },
};


